import React from 'react';
import { Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';

// Header shortcut to /admin, rendered only for admin accounts.
const AdminLink = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!user?.is_admin) return null;
  return (
    <Button variant="ghost" size="sm" data-testid="admin-panel-link" onClick={() => navigate('/admin')} title="Panel de Administración" className="text-emerald-700 hover:text-emerald-900 hover:bg-emerald-50">
      <Shield size={20} />
      <span className="hidden sm:inline ml-1 text-xs font-semibold">Admin</span>
    </Button>
  );
};

export default AdminLink;
